export default "__VITE_ASSET__Qx3ekRx___"